import { isPvmGpsTemplate } from './templateConstants';

/** PVM AG / GPS factsheet brand typography and colors. */
export const PVM_HEADLINE_COLOR = '#172D59';
export const PVM_TEXT_COLOR = '#26364A';

export const PVM_HEADLINE_FONT = 'Playfair Display';
export const PVM_BODY_FONT = 'Open Sans';
export const PVM_HEADLINE_FONT_STACK = '"Playfair Display", Georgia, "Times New Roman", serif';
export const PVM_BODY_FONT_STACK = '"Open Sans", "Helvetica Neue", Arial, sans-serif';

/** PDF font files — Playfair Display (headlines) + Open Sans (body). */
export const PVM_FONT_FILES = {
  playfairRegular: '/fonts/PlayfairDisplay-Regular.ttf',
  playfairBold: '/fonts/PlayfairDisplay-Bold.ttf',
  openSansRegular: '/fonts/OpenSans-Regular.ttf',
  openSansBold: '/fonts/OpenSans-Bold.ttf',
} as const;

/** @deprecated Use PVM_FONT_FILES — kept for any stale imports */
export const PVM_GEORGIA_FONT_FILES = {
  regular: PVM_FONT_FILES.openSansRegular,
  bold: PVM_FONT_FILES.playfairBold,
} as const;

export const PVM_FONT_STACK = PVM_BODY_FONT_STACK;

export const PVM_DONUT_COLORS = [
  PVM_HEADLINE_COLOR,
  '#2A4A7A',
  '#4A6FA5',
  '#6B8AB8',
  '#58585a',
  '#7A7A7A',
  '#949599',
  '#A7A8AB',
  '#3D5A80',
  '#8B95A5',
  '#B0B4B8',
  '#C5C7CA',
];

/** PVM header main title — sized so "Global Premium Select P" fits on one line. */
export const PVM_HEADER_TITLE_FONT_SIZE_WEB = 26;
export const PVM_HEADER_TITLE_FONT_SIZE_PDF = 20;

export function resolvePvmHeadlineColor(templateId?: string, templateColor?: string): string {
  return isPvmGpsTemplate(templateId) ? PVM_HEADLINE_COLOR : (templateColor || '#003f7a');
}

export function resolvePvmBodyColor(templateId?: string, fallback = '#000000'): string {
  return isPvmGpsTemplate(templateId) ? PVM_TEXT_COLOR : fallback;
}

export function withPvmHeadlineStyle<T extends object>(base: T, isPvm: boolean): T {
  if (!isPvm) return base;
  return {
    ...base,
    fontFamily: PVM_HEADLINE_FONT_STACK,
    color: PVM_HEADLINE_COLOR,
    fontWeight: 700,
    borderBottomColor: PVM_HEADLINE_COLOR,
  };
}

export function withPvmBodyStyle<T extends object>(base: T, isPvm: boolean): T {
  if (!isPvm) return base;
  return { ...base, fontFamily: PVM_BODY_FONT_STACK, color: PVM_TEXT_COLOR, fontWeight: 400 };
}

export function wrapPvmTitleStyle(
  base: (theme?: any) => object,
  isPvm: boolean,
): (theme?: any) => object {
  if (!isPvm) return base;
  return (theme?: any) => withPvmHeadlineStyle(base(theme), true);
}

export function wrapPvmTitleStyle2(
  base: (template?: any) => object,
  isPvm: boolean,
): (template?: any) => object {
  if (!isPvm) return base;
  return (template?: any) => withPvmHeadlineStyle(base(template), true);
}

export function wrapPvmBodyStyleFn(
  base: (theme?: any) => object,
  isPvm: boolean,
): (theme?: any) => object {
  if (!isPvm) return base;
  return (theme?: any) => withPvmBodyStyle(base(theme), true);
}

export const pvmPaperFontSx = {
  fontFamily: PVM_BODY_FONT_STACK,
  '& [data-pvm-headline="true"]': {
    fontFamily: PVM_HEADLINE_FONT_STACK,
  },
};
